let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("caY5k")).then(() => parcelRequire('dqR1S'));